<div id="doctors-list" class="flex flex-col gap-3">
  <nz-table #nzTable [nzData]="listOfDisplayData" nzTableLayout="fixed" [nzLoading]="!doctors"
    [nzFrontPagination]="false">
    <thead>
      <tr>
        <th nzCustomFilter>
          Doctor Name
          <nz-filter-trigger [(nzVisible)]="visible" [nzActive]="searchValue.length > 0" [nzDropdownMenu]="menu">
            <nz-icon nzType="search" />
          </nz-filter-trigger>
        </th>
        <th>Patient Count</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (doctor of nzTable.data; track doctor.id) {
      <tr>
        <td>{{ doctor.first_name }} {{ doctor.last_name }}</td>
        <td>{{ doctor.patients_count }}</td>
        <td>
          <button nz-button nzType="primary" nzSize="small" (click)="openDoctor(doctor)">
            View Patients
          </button>
        </td>
      </tr>
      }
    </tbody>
  </nz-table>

  <div class="flex justify-center mt-4">
    <nz-pagination [nzPageIndex]="page" [nzTotal]="total" [nzPageSize]="pageSize" [nzShowSizeChanger]="false"
      [nzShowQuickJumper]="false" [nzShowTotal]="totalTemplate" (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>

  <ng-template #totalTemplate let-total let-range="range">
    {{ range[0] }}-{{ range[1] }} of {{ total }} doctors
  </ng-template>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search doctor name" [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
</div>
